import React from 'react';
import { formatAgo } from '../util/date';
import { useNavigate } from 'react-router-dom';


export default function VideoCard({ video }) {
    const {title, thumbnails, channelTitle, publishedAt } = video.snippet;
    const navigate = useNavigate();
    return <li onClick={() => {navigate(`videos/watch/${video.id}`, {state: { video }})}}>
        <img className='w-100' src={thumbnails.medium.url} alt={title} />
        <div>
            <p className='fw-semibold my-2 text-truncate'>{title}</p>
            <p className='small' style={{ opacity: 0.75 }}>{channelTitle}</p>
            <p className='small' style={{ opacity: 0.75 }}>{formatAgo(publishedAt)}</p>
        </div>
    </li>
}

